import React, { useContext, useEffect, useState } from "react";
import { Grid, Divider } from "@mui/material";
import styles from "./styles.module.css";
import ShopContext from "context/ShopContext";
import * as TerminalHelper from "helpers/TermialHelper";
import { STORAGE_KEYS } from "const";

const ShopDetails = () => {
  const { selectedShop } = useContext(ShopContext);
  const terminalId = TerminalHelper.getCurrentTerminalId();
  const [terminalName, setTerminalName] = useState(
    () => TerminalHelper.getCurrentTerminalName() || localStorage.getItem(STORAGE_KEYS.TERMINAL_NAME) || ""
  );

  useEffect(() => {
    if (!terminalId || terminalName) return;

    TerminalHelper.getPosTerminals()
      .then((terminals) => {
        const currentTerminal = (terminals || []).find(
          (terminal) => String(terminal.id) === String(terminalId)
        );
        if (currentTerminal?.name) {
          setTerminalName(currentTerminal.name);
          localStorage.setItem(STORAGE_KEYS.TERMINAL_NAME, currentTerminal.name);
        }
      })
      .catch((error) => console.error("Failed to load terminal name:", error));
  }, [terminalId, terminalName]);

  if (!selectedShop) {
    return <div>Loading shop details...</div>;
  }

  const renderDetailItem = (label, value) => {
    if (value === null || value === undefined) return null;

    return (
      <Grid item xs={12} sm={6} md={4} key={label}>
        <div className={styles.container} style={{ padding: "10px", height: "auto" }}>
          <h3 className={styles.label} style={{ fontSize: "12px", color: "#7c7c7d", margin: 0 }}>
            {label}
          </h3>
          <h4
            className={styles.value}
            style={{ fontSize: "14px", fontWeight: "600", color: "#2b2b2b", marginTop: "4px" }}
          >
            {value}
          </h4>
        </div>
      </Grid>
    );
  };

  const sxHeader = {
    fontSize: "14px",
    fontWeight: "700",
    color: "#2b2b2b",
    marginBottom: "10px",
    marginTop: "10px",
  };

  const basicInfo = [
    { label: "Shop Name", value: selectedShop.shop_name },
    { label: "Mobile Number", value: selectedShop.mobile_no },
    { label: "Status", value: selectedShop.status },
    { label: "Category", value: selectedShop.category },
    { label: "Sub Category", value: selectedShop.sub_category },
  ];

  const terminalDetails = [
    { label: "Terminal Name", value: terminalName || "-" },
    { label: "Terminal ID", value: terminalId || "-" },
  ];
  const subscriptionInfo = [
    { label: "Subscription Name", value: selectedShop.subscription?.name },
    { label: "Subscription End Date", value: selectedShop.subscription_end_date },
    {
      label: "Rate",
      value: selectedShop.subscription?.rate
        ? `${selectedShop.currency_symbol} ${selectedShop.subscription?.rate}`
        : null,
    },
    { label: "Days", value: selectedShop.subscription?.days },
    { label: "Max Machines", value: selectedShop.subscription?.max_machines },
    { label: "Description", value: selectedShop.subscription?.description },
  ];

  const validities = [
    { label: "KOT Validity", value: selectedShop.kot_validity },
    { label: "KOT Lite Validity", value: selectedShop.kot_lite_validity },
    { label: "Kitchen Display Validity", value: selectedShop.kitchen_display_validity },
    { label: "Online Cart Validity", value: selectedShop.online_cart_validity },
    { label: "Queue Display Validity", value: selectedShop.queue_display_validity },
    { label: "Bluetooth Scale Validity", value: selectedShop.bluetooth_scale_validity },
    { label: "Smart Scale Validity", value: selectedShop.smart_scale_validity },
    { label: "Image Support Validity", value: selectedShop.image_support_validity },
    { label: "Expense Validity", value: selectedShop.expense_validity },
    { label: "Customer Support Validity", value: selectedShop.customer_support_validity },
    { label: "Quickbook Support Validity", value: selectedShop.quickbook_support_validity },
    { label: "Zoho Support Validity", value: selectedShop.zoho_support_validity },
  ];

  const dealerInfo = [
    { label: "Dealer Name", value: selectedShop.dealer?.name },
    { label: "Customer Support Number", value: selectedShop.dealer?.customer_support_number },
    { label: "Online Renewal Enabled", value: selectedShop.dealer?.is_online_renewal_enabled ? "Yes" : "No" },
  ];

  const otherInfo = [
    { label: "Tax Preference", value: selectedShop.tax_preference },
    { label: "Tax Type", value: selectedShop.tax_type },
    { label: "Tax Region", value: selectedShop.tax_region },
    { label: "Units", value: selectedShop.units },
    {
      label: "Currency",
      value: selectedShop.currency_name ? `${selectedShop.currency_name} (${selectedShop.currency_symbol})` : null,
    },
  ];

  const renderSection = (title, items) => {
    const renderedItems = items.map((item) => renderDetailItem(item.label, item.value)).filter(Boolean);
    if (renderedItems.length === 0) return null;

    return (
      <React.Fragment key={title}>
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={12}>
            <h3 style={sxHeader}>{title}</h3>
          </Grid>
          {renderedItems}
        </Grid>
        <Divider sx={{ my: 1 }} />
      </React.Fragment>
    );
  };

  return (
    <div className={styles.contentWrapper}>
      <div className={styles.scrollableArea}>
        {renderSection("Basic Information", basicInfo)}
        {renderSection("Terminal Details", terminalDetails)}
        {renderSection("Subscription Details", subscriptionInfo)}
        {renderSection("Service Validities", validities)}
        {renderSection("Dealer Information", dealerInfo)}
        {renderSection("Other Settings", otherInfo)}
      </div>
    </div>
  );
};

export default ShopDetails;
